export const columns: {
  identifier: string;
  title: string;
}[] = [
  {
    identifier: 'datetime',
    title: 'DATE',
  },
  {
    identifier: 'username',
    title: 'UPLOADED BY',
  },
  {
    identifier: 'filename',
    title: 'FILE',
  },
];
